export const chatUserName = (name, chatConfig = {}) => {
  if (!name) {
    return ''
  }
  if (chatConfig.userFirstNameOnly) {
    return name.split(' ')[0]
  }
  return name
}
